<div class="d-grid align-content-center route-container" [ngStyle]="{ 'margin-top': introAlignment() == 'center' ? '90px' : '60px' }">
  <div class="route-content justify-content-center">
    <div class="route-page-container d-flex flex-column psic-mx-8 psic-gap-8">
      @if (intro() || introSub()) {
        <div
          class="d-grid animate-header"
          [ngClass]="introAlignment() == 'center' ? 'justify-content-center' : 'justify-content-flex-start'"
          >
          <h5 [innerHTML]="intro()" class="mobile" [ngClass]="{ 'text-center': introAlignment() == 'center' }"></h5>
          <h2 [innerHTML]="intro()" class="desktop" [style.maxWidth]="introTextMaxWidth()" [ngClass]="{ 'text-center': introAlignment() == 'center' }"></h2>
          <p [innerHTML]="introSub()" class="alt p-1" [style.maxWidth]="introSubMaxWidth()" [ngClass]="{ 'text-center': introAlignment() == 'center' }"></p>
        </div>
      }
      <div class="animate-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div>
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
